import styled, { css } from "styled-components/macro";

import { ReactComponent as IconClose } from "../../assets/icons/icon_close.svg";
import { ReactComponent as IconShevron } from "../../assets/icons/icon_shevron.svg";
import { baseButtonStyles } from "../../styles/sharedStyles";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  z-index: 1000;
  padding-top: 30px;
  align-items: flex-start;
  overflow-y: auto;

  @media (max-width: 664px) {
    padding: 0;
  }
`;

export const PopupWrapper = styled.div`
  background-color: #fff;
  border-radius: 24px;
  width: 100%;
  max-width: 664px;
  min-height: 470px;
  padding: 60px; // design
  //padding: 40px;
  position: relative;

  @media (max-width: 664px) {
    max-width: 100%;
    min-height: 100vh;
    padding: 60px 12px 12px;
    border-radius: 0;
  }
`;

export const StepsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px; // design
  //margin-bottom: 10px;
  position: relative;
`;

export const StepItem = styled.div`
  text-align: center;
  flex: 1;
  position: relative;
`;

export const StepCircle = styled.div<{ $active?: boolean; $passed?: boolean }>`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${({ $active, $passed }) =>
    $passed ? "#fff" : $active ? "#BFDCF5" : "#fff"};
  border: 1px solid
    ${({ $active, $passed }) =>
    $passed ? "#55749F" : $active ? "#141414" : "#A7A7A7"};
  color: ${({ $active, $passed }) =>
    $passed ? "#55749F" : $active ? "#000" : "#999"};
  margin: 0 auto;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  z-index: 1;
  transition: background 0.3s, border 0.3s, color 0.3s;

  @media (max-width: 664px) {
    width: 30px;
    height: 30px;
    font-size: 13px;
  }
`;

export const StepLine = styled.div<{$filled?: boolean}>`
  position: absolute;
  height: 1px;
  min-width: calc(100% - 40px);
  left: 61%;
  background: #A7A7A7;  
  top: 20px;
  z-index: 0;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: ${({ $filled }) => ($filled ? "100%" : "0%")};
    background-color: #55749F;
    transition: width 0.9s ease-out;
  }

  @media (max-width: 664px) {
    width: calc(100% - 30px);
    top: 15px;
    left: 62%;
    transform: translateY(-50%);
  }
`;

export const StepLabel = styled.div<{ $active?: boolean; $passed?: boolean }>`
  font-size: 16px;
  color: ${({ $active, $passed }) =>
    $passed ? "#55749F" : $active ? "#141414" : "#A7A7A7"};
  margin-top: 6px;
  transition: color 0.3s;

  @media (max-width: 664px) {
    font-size: 13px;
  }
`;

export const CloseContainer = styled.div`
  padding: 15px;
  position: absolute;
  right: 12px;
  top: 12px;
  display: flex;
  align-items: center;
`

export const Close = styled(IconClose)`
  width: 18px;
  height: 18px;
  cursor: pointer;
  transition: 0.2s;
  
  path {
    stroke: #141414;
  }
  
  &:hover {
    transition: 0.2s;
    transform: scale(1.2);
  }
`

export const StepWrapper = styled.div`
  margin-top: 24px; // design
  //margin-top: 0; // test
`;

export const StepContainer = styled.div`
  display: flex;
  flex-direction: column;
  
  @media (max-width: 664px) {
    justify-content: flex-start;
  }
`;

export const StepTitle = styled.h3`
  font-family: "Cormorant Infant", sans-serif;
  font-size: 35px;
  text-align: center;
  line-height: 86%;
  font-weight: 600;
  margin-bottom: 36px; // design
  //margin-bottom: 20px;
  
  @media (max-width: 664px) {
    font-size: 30px;
  }
`;

export const CustomStepTitle = styled(StepTitle)`
  margin-bottom: 14px;
`

export const TimeSlotWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
  margin-bottom: 40px;
`

type TTimeSlot = {
  selected?: boolean,
}

export const TimeSlot = styled.div<TTimeSlot>`
  width: 110px;
  height: 55px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: ${({ selected }) => (
    selected
      ? "2px solid #1983FF"
      : "1px solid #EEEFF0"
  )};
  
  span {
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 0;
    
  }

  &:hover {
    ${({ selected }) =>
    !selected &&
        css`
        background: #f0f0f0;
      `}
  }
`

export const NoSlotsWarn = styled.p`
  height: 55px;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0;
  text-align: center;
`

export const Description = styled.p`
  color: #A7A7A7;
  font-size: 18px;
  font-weight: 400;
  text-align: center;
  margin-bottom: 36px;
`

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  
  @media (max-width: 664px) {
    margin-top: auto;
  }
`

export const NextButton = styled.button`
  box-sizing: border-box;
  width: 100%;
  font-weight: 500;
  min-height: 50px;
  background-color: #BFDCF5;
  border: 1px solid #141414;
  border-radius: 30px;
  cursor: pointer;
  font-size: 18px;
  text-align: center;
  transition: 0.4s;

  &:hover {
    background-color: black;
    color: white;
    transition: 0.4s;
  }
  
  &:disabled {
    background-color: #EEEFF0;
    color: #DDDEE4;
    border-color: #EEEFF0;
    pointer-events: none;
  }
  
  @media (max-width: 664px) {
    margin-top: auto;
  }
`;

export const BackButton = styled(NextButton)`
  min-width: 97px;
  width: 97px;
  background-color: #fff;
`

export const CalendarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
  border: 1px solid #DDDEE4;
  border-radius: 24px;

  @media (max-width: 664px) {
    border-radius: 12px;
  }
`;

export const CalendarHeader = styled.div`
  display: flex;
  min-height: 44px;
  justify-content: space-between;
  align-items: center;
  padding: 0 26px;
  border-bottom: 1px solid rgb(221, 222, 228);
`;

export const NavButtonWrapper = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const NavButton = styled(IconShevron)`
  min-width: 5px;
  height: 10px;
  cursor: pointer;
  transition: 0.2s;
  transform: rotate(90deg);
  
  path {
    stroke: #141414;
  }
`

export const NavButtonNext = styled(NavButton)`
  transform: rotate(-90deg);
`

export const CalendarTitle = styled.div`
  font-size: 18px;
  font-weight: 400;
  text-transform: capitalize;
  
  @media (max-width: 664px) {
    font-size: 16px;
  }
`;

export const CalendarGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 12px; // design
  //gap: 5px;
  padding: 0 26px 26px; // design
  //padding: 0 26px 10px;

  @media (max-width: 664px) {
    padding: 0 12px 12px;
  }
`;

type CalendarCellProps = {
    selected?: boolean;
    isOutsideCurrentMonth?: boolean;
    isDisabled?: boolean;
};

export const CalendarCell = styled.div<CalendarCellProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0;
  height: 60px; // design
  //height: 40px;
  border-radius: 8px;
  background-color: transparent;
  user-select: none;
  border: ${({ selected }) => (selected ? "2px solid #1983FF" : "none")};
  color: #141414;

  ${({ isDisabled, isOutsideCurrentMonth }) => {
    switch (true) {
    case isOutsideCurrentMonth && isDisabled:
      return css`
          color: #EEEFF0;
          cursor: auto;
          pointer-events: none;
        `;

    case isOutsideCurrentMonth && !isDisabled:
      return css`
          color: #EEEFF0;
        `;

    case isDisabled:
      return css`
          color: #A7A7A7;
          cursor: auto;
          pointer-events: none;
        `;

    default:
      return css`
          cursor: pointer;
        `;
    }
  }}

  &:hover {
    ${({ selected, isDisabled }) =>
    !selected && !isDisabled &&
    css`
        background: #f0f0f0;
      `}
  }

  @media (max-width: 664px) {
    font-size: 16px;
  }
`;

export const FieldWrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  margin-top: 26px;
  padding: 0 15px;
  min-height: 88px; // design
  //min-height: 79px;

  @media (max-width: 664px) {
    margin-bottom: 0;
  }
`;

export const CheckboxFieldWrapper = styled(FieldWrapper)`
  margin-top: 36px;
  min-height: 20px; // design
  padding: 0;
  margin-bottom: 40px; // design
  //margin-bottom: 20px;
`

export const Label = styled.label`
  font-size: 16px;
  line-height: 140%;
`;

export const Input = styled.input<{ hasError?: boolean }>`
  min-height: 43px;
  line-height: 140%;
  font-size: 22px; // design
  //font-size: 18px;
  border: none;
  border-bottom: 1px solid ${({ hasError }) => (hasError ? "#FF4D4F" : "#141414")};
  outline: none;
  background: transparent;
  border-radius: 0;

  &::placeholder {
    color: #DDDEE4;
    font-size: 22px; // design
    //font-size: 18px;
  }
`;

export const ErrorMessage = styled.div`
  color: #F4502F;
  font-size: 16px;
  line-height: 17px;
  margin-top: 6px;
`;

export const CalendarWeekGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 12px;
  padding: 26px 26px 0; // design
  //padding: 10px 26px 0;
  margin-bottom: 12px;

  @media (max-width: 664px) {
    padding: 12px 12px 0;
  }
`

export const CalendarWeekDayCell = styled.div`
  height: 16px;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  color: #55749F;
`

export const ServiceDropdown = styled.div<{ hasError?: boolean }>`
  //font-size: 22px; // design
  //font-size: 18px; // design
  padding: 6px 0;
  border: none;
  border-bottom: 1px solid ${({ hasError }) => (hasError ? "#FF4D4F" : "#141414")};
  background: transparent;
  outline: none;
  cursor: pointer;
`;

export const Shevron = styled(IconShevron)<{$isOpened?: boolean}>`
  width: 16px;
  height: 8px;
  position: absolute;
  top: 50%;
  right: 0;
  transition: 0.2s;
  transform: rotate(${({ $isOpened }) => ($isOpened ? "180deg" : "0deg")});
`

export const ServiceDropdownList = styled.ul`
  background-color: #F8F8F8;
  height: auto;
  width: 100%;
  position: absolute;
  border-radius: 16px;
  top: 75px;
  left: 0;
  z-index: 10;
`

export const ServiceItem = styled.li`
  //font-size: 22px; // design
  font-size: 18px; // design
  //line-height: 140%;
  padding: 8px 12px;
  cursor: pointer;
  
  &:hover {
    color: #1983FF;
  }
`

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 11px;
  margin-top: 10px;
`;

export const Checkbox = styled.input`
  margin-top: 1px;
  min-width: 16px;
  height: 16px;
  accent-color: #141414;
`;

export const PolicyText = styled.p`
  font-size: 16px;
  line-height: 21px;
  letter-spacing: -1px;
  color: #141414;

  a {
    color: #55749F;
    text-decoration: underline;
  }
`;

export const InfoBlock = styled.div`
  font-size: 22px;
  font-weight: 400;
  line-height: 140%;
  text-align: center;
  margin-bottom: 40px;
  
  span {
    font-weight: 500;
    color: #1983FF;
  }
  
  @media (max-width: 664px) {
    font-size: 16px;
  }
`

export const SummaryBlock = styled.div`
  background-color: #F8F8F8;
  border-radius: 20px;
`

export const Block = styled.div`
  padding: 20px 32px 32px;
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;

  &:not(:last-child) {
    border-bottom: 1px dashed #B4B4B4;
  }
  
  &:last-child {
    padding-top: 32px;
  }
  
  span {
    font-size: 16px;
    letter-spacing: -0.02em;
    line-height: 140%;
    text-align: center;
    
    @media (max-width: 664px) {
      font-size: 15px;
    }
  }
`

export const TGButton = styled.a`
  ${baseButtonStyles};
  margin-top: 26px;
  background-color: #BFDCF5;
  white-space: nowrap;
  width: 188px;
  height: 44px;
  line-height: 16px;
  font-size: 16px;
  padding: 14px 24px;
  display: block;
`
